export const PAYMENT_TYPES = {
  ONLINE: "online",
  OFFLINE: "offline",
  CREDIT: "credit",
};
